import React, { useState } from "react"
import toast from "react-hot-toast"
import { useHistory } from "react-router-dom"
import { Col, Row } from "reactstrap"
import { DragDropContext, Droppable } from "react-beautiful-dnd"

import { useParams } from "react-router-dom/cjs/react-router-dom.min"

import {
   DeleteTrailerPackage,
   GetTrailerPackagesListing,
   UpdateTrailerPackage,
   GetPackagesListing,
   UpdateTrailerPackageSequence,
} from "../../../api/api.service"
import { AutoComplete } from "../../../components/AutoComplete"
import { Button } from "../../../components/Button"
import { DataTable } from "../../../components/DataTable"
import { Pagination } from "../../../components/Pagination"
import { SearchBox } from "../../../components/SearchBox"
import { ConfiguratorPackagesStatus } from "../../../constants"
import { APP_ROUTES, getRoute } from "../../../helpers/routeHelpers"
import { useLocalPaginatedRequest } from "../../../hooks/useLocalPaginatedRequest"
import {
   convertToSelectOptions,
   replaceSlashes,
} from "../../../utils/commonUtils"
import ActiveInactiveSwitch from "../CommonUI/ActiveInactiveSwitch/ActiveInactiveSwitch"
import DeleteModal from "../CommonUI/Modal/DeleteModal"
import { TOGGLE_STATUS } from "./FormConfig"
import ManagePackages from "./ManagePackages"

import editIcon from "../../../assets/images/icons/edit-icon.svg"
import eyeIcon from "../../../assets/images/icons/eye-icon.svg"
import DeleteIcon from "assets/images/icons/finance-vendor-mang-del-icon.svg"
import settingsIcon from "../../../assets/images/icons/settings-icon.svg"
import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"
import useAsyncSelect from "hooks/useAsyncSelect"
import ManageImportGlobalPackageModal from "./ManageImportGlobalPackageModal"
import TruncatedTextWithTooltip from "components/CustomTooltip/CustomTooltip"

const COLUMNS = {
   ITEM_NAME: "Package name",
   PACKAGE_MARKETING_PRICE: "Marketing Price",
   PACKAGE_PRODUCTION_COST: "Production Cost",
   STATUS: "Status",
   ACTIONS: "Actions",
   CUSTOMIZE: "Customize",
   ITEM_COUNT: "Item Count",
   POPULAR_PACKAGE: "Popular Package",
}
const DATA_KEY = "data"
const TOTAL_KEY = "total"

const Packages = ({}) => {
   const { trailerId } = useParams()
   const history = useHistory()
   const [statusFilters, setStatusFilters] = useState(null)
   const [delId, setDelId] = useState(null)
   const [selection, setSelection] = useState({})
   const [openDelModal, setOpenDelModal] = useState(false)
   const [selectedPackage, setSelectedPackage] = useState(null)
   const [openSelectPackagesModal, setOpenSelectPackagesModal] = useState(false)
   const [selectedPackages, setSelectedPackages] = useState([])

   const {
      data,
      isFetching,
      page,
      searchText,
      pageSize,
      total,
      handleSearchChange,
      request,
      handlePageClick,
      onChangePageSize,
      setTableDataChangeLoading,
      tableDataChangeLoading,
      setData,
   } = useLocalPaginatedRequest({
      requestFn: GetTrailerPackagesListing,
      params: {
         limit: -1,
         trailerId: trailerId,
         ...(statusFilters?.value && { status: statusFilters?.value }),
         direction: "ASC",
         column: "sequenceNo",
      },
      deps: [statusFilters],
      dataKey: DATA_KEY,
      totalKey: TOTAL_KEY,
   })

   const {
      selectEntity: packagesOptions,
      setSelectEntity: setPackagesOptions,
      handleSearchOnOptions: handleSearchPackage,
   } = useAsyncSelect({
      apiFunc: GetPackagesListing,
      labelKey: "packageName",
      valueKey: "id",
      restrictExecutionOnRender: false,
      params: {
         limit: -1,
      },
      modifyLabel: true,
      handleLabelModification: options => {
         return options.map(item => {
            const { description, ...rest } = item
            return {
               ...rest,
               label: item.packageName || "",
            }
         })
      },
      onOptionSelect: option => {
         setSelectedPackage(option)
      },
   })

   const [eventsType, setEventsType] = useState({
      isManage: null,
      isUpdate: null,
      isDetails: null,
   })

   const handleInitManage = obj => {
      setEventsType(prev => ({ ...prev, isManage: true }))
      setSelection(obj)
   }

   const handleInitViewDetails = obj => {
      setSelection(obj)
      setEventsType(prev => ({ ...prev, isDetails: true, isManage: true }))
   }

   const handleSelectStatusOption = option => {
      setStatusFilters(option)
   }

   const handleStatusChange = async (currStatus, id) => {
      let status =
         currStatus === ConfiguratorPackagesStatus.Active
            ? ConfiguratorPackagesStatus.Inactive
            : ConfiguratorPackagesStatus.Active
      let dataClone = [...data]
      dataClone.map(el => {
         if (el?.id == id) el.status = status
      })
      setData(dataClone)
      let payload = {
         status: status,
      }
      try {
         setTableDataChangeLoading(true)
         let res = await UpdateTrailerPackage(id, payload)
         toast.success("Package status has been updated !")
      } catch (err) {
         let dataClone = [...data]
         dataClone.map(el => {
            if (el?.id == id) el.status = currStatus
         })
         setData(dataClone)
      } finally {
         setTableDataChangeLoading(false)
      }
   }

   const handleNavigateToPackagesItems = obj => {
      setSelection(obj)

      return history.push(
         getRoute(APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_PACKAGES_ITEMS, {
            trailerId: trailerId,
            packageId: obj.id,
            packageName: replaceSlashes(obj.packageName),
         })
      )
   }

   const handleInitDelete = obj => {
      setDelId(obj.id)
      setOpenDelModal(prev => !prev)
   }

   const handleDragEnd = async result => {
      if (!result.destination) return

      const items = Array.from(data)
      const [reorderedItem] = items.splice(result.source.index, 1)
      items.splice(result.destination.index, 0, reorderedItem)

      setData(items)

      let payload = {
         trailerId: trailerId,
         sequenceItems: items.map((trailerObj, ind) => ({
            id: Number(trailerObj.id),
            sequenceNo: ind,
         })),
      }

      try {
         await UpdateTrailerPackageSequence(payload)
         toast.success("Sequence updated successfully!")
      } catch (err) {
         toast.error("Failed to update sequence")
      }
   }
   return (
      <>
         <div className="mb-3 trailer-container">
            <div className="d-flex align-items-center justify-content-end admin-inventory-management-general-inventory-responsiveness trailer-btn-container">
               <Button
                  className={`header-button headerButtonResponsive global-selection-button`}
                  title="Select Packages"
                  onClick={() => setOpenSelectPackagesModal(true)}
               />

               <Button
                  className={`header-button headerButtonResponsive global-selection-button`}
                  title="Add Package"
                  onClick={() => handleInitManage({})}
               />
            </div>
         </div>

         <div className="mb-3">
            <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness ">
               <div className="status-search-con wh-im-dpgi-status  me-2 ">
                  <AutoComplete
                     value={statusFilters}
                     isClearable
                     onChange={val => handleSelectStatusOption(val)}
                     isSearchable={false}
                     placeholder="Select status"
                     customStyles={autoCompleteStyles.STYLE_SIX}
                     classNamePrefix="status-header-search-admin"
                     options={convertToSelectOptions(
                        ConfiguratorPackagesStatus
                     )}
                  />
               </div>
               <div className="ad-location-search-box">
                  <SearchBox
                     inputClasses="vendor-search-input input-search"
                     labelClass="d-none"
                     placeholder="Search"
                     searchIcon={true}
                     searchIconClass="vendor-table-search-icon"
                     conClass="vendor-table-search-inner-class"
                     searchText={searchText}
                     onChange={handleSearchChange}
                  />
               </div>
            </div>
         </div>

         <Row>
            <Col md={12}>
               <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="droppable">
                     {provided => (
                        <div
                           {...provided.droppableProps}
                           ref={provided.innerRef}
                        >
                           <DataTable
                              isDraggable={true}
                              droppablePlaceholder={provided.placeholder}
                              data={data}
                              tableClasses="package-table"
                              loading={isFetching}
                              config={[
                                 {
                                    title: COLUMNS.ITEM_NAME,
                                    className: "",
                                    render: data => (
                                       <TruncatedTextWithTooltip
                                          text={data.packageName}
                                       />
                                    ),
                                 },

                                 {
                                    title: COLUMNS.PACKAGE_PRODUCTION_COST,
                                    className: "",
                                    render: data =>
                                       `$${Number(
                                          data?.productionPrice
                                       ).toFixed(2)}` || "-",
                                 },

                                 {
                                    title: COLUMNS.PACKAGE_MARKETING_PRICE,
                                    className: "",
                                    render: data =>
                                       `$${Number(data?.price).toFixed(2)}` ||
                                       "-",
                                 },
                                 {
                                    title: COLUMNS.CUSTOMIZE,
                                    className: "",
                                    render: data =>
                                       data.isCustomizable ? "Yes" : "No",
                                 },
                                 {
                                    title: COLUMNS.ITEM_COUNT,
                                    className: "",
                                    render: data =>
                                       data.configuratorTrailerPackagesItems
                                          ?.length,
                                 },
                                 {
                                    title: COLUMNS.POPULAR_PACKAGE,
                                    className: "",
                                    render: data =>
                                       data?.isPopular
                                          ? TOGGLE_STATUS.Yes
                                          : TOGGLE_STATUS.No,
                                 },

                                 {
                                    title: COLUMNS.STATUS,
                                    className: "",
                                    render: data => (
                                       <ActiveInactiveSwitch
                                          isDisable={tableDataChangeLoading}
                                          id={data.id}
                                          name={`${data.id}`}
                                          onChange={e =>
                                             handleStatusChange(
                                                data?.status,
                                                data?.id
                                             )
                                          }
                                          isChecked={
                                             data?.status ==
                                             ConfiguratorPackagesStatus.Active
                                          }
                                       />
                                    ),
                                 },

                                 {
                                    title: COLUMNS.ACTIONS,

                                    render: data => (
                                       <div className="d-flex gap-2 pointer">
                                          <img
                                             src={eyeIcon}
                                             onClick={() =>
                                                handleInitViewDetails(data)
                                             }
                                          />

                                          <img
                                             src={editIcon}
                                             onClick={() =>
                                                handleInitManage(data)
                                             }
                                          />
                                          <img
                                             src={settingsIcon}
                                             onClick={() =>
                                                handleNavigateToPackagesItems(
                                                   data
                                                )
                                             }
                                          />
                                          <img
                                             src={DeleteIcon}
                                             onClick={() =>
                                                handleInitDelete(data)
                                             }
                                          />
                                       </div>
                                    ),
                                 },
                              ]}
                           />
                        </div>
                     )}
                  </Droppable>
               </DragDropContext>
            </Col>
            <Pagination
               currentPage={page}
               totalData={total}
               onPageClick={handlePageClick}
               rowLimit={pageSize}
               onChangePageSize={onChangePageSize}
            />
         </Row>

         <ManagePackages
            isDetailView={eventsType.isDetails}
            isOpen={eventsType.isManage}
            id={selection?.id}
            onSuccess={request}
            onToggleModal={() => {
               setSelection({})
               setEventsType(prev => ({
                  ...prev,
                  isManage: false,
                  isDetails: false,
               }))
            }}
         />

         <ManageImportGlobalPackageModal
            isOpen={openSelectPackagesModal}
            onToggleModal={() => {
               setOpenSelectPackagesModal(false)
               setSelectedPackages([])
            }}
            packagesOptions={packagesOptions}
            setPackagesOptions={setPackagesOptions}
            handleSearchPackage={handleSearchPackage}
            selectedPackages={selectedPackages}
            setSelectedPackages={setSelectedPackages}
            trailerId={trailerId}
            onSuccess={request}
            existingTrailerPackages={data || []}
         />

         <DeleteModal
            isOpen={openDelModal}
            toggleFunction={setOpenDelModal}
            id={delId}
            apiFunction={DeleteTrailerPackage}
            title={"Package"}
            requestFunction={() => {
               setDelId(null)
               request()
            }}
         />
      </>
   )
}

export default Packages
